import { fetchApp, selectAppById } from "@app/deploy";
import { selectDeploymentById } from "@app/deployment";
import { useQuery, useSelector } from "@app/react";
import { useParams } from "react-router";
import { AppConfigView, Box, Group, tokens } from "../shared";

export function DeploymentDetailConfigPage() {
  const { id = "" } = useParams();
  const deployment = useSelector((s) => selectDeploymentById(s, { id }));
  useQuery(fetchApp({ id: deployment.appId }));
  const app = useSelector((s) => selectAppById(s, { id: deployment.appId }));

  return (
    <Box>
      <Group size="sm">
        <h3 className={tokens.type.h3}>Current Environment Variables</h3>
        <AppConfigView
          configId={deployment.configurationId}
          envId={app.environmentId}
        />
      </Group>
    </Box>
  );
}
